import $ from 'jquery';

import { i18n } from '../../translation.js';
import template from './socialfeed.vhtml';

export default {
	template,
	props: {
		callOutLink: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			feed: [],
			isLoading: false,
			callOut: {
				title: i18n.t( 'followEveryDay' ) + ' Instagram',
				profileName: 'erhvervsakademi_sydvest',
				linkText: i18n.t( 'seeImgsFromEveryDay' ),
				caption: { text: '' },
				images: { standard_resolution: { url: '' } },
			},
			callOutPlace: 4,
		};
	},
	methods: {
		reload() {
			this.isLoading = true;
			getItems( this.postType, this.filters )
			.then( items => {
				if ( items ) {
					let arr = JSON.parse(items);
					arr = arr.feed
					arr.splice( this.callOutPlace, 0, this.callOut );
					this.feed = arr;
				}
			})
			.always( () => this.isLoading = false );
		},
	},
	created() {
		this.reload();
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems() {
	const params = {
		'limit': 7,
	};

	return $.get( `https://api.socialfeeds.qnty.dk/feed/easv/instagram`, params );
}



// WEBPACK FOOTER //
// ./assets/_js/components/socialfeed/socialfeed.js